import ItemTypeFieldValidatorsModel from '#model/ItemTypeFieldValidatorsModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class ItemTypeFieldValidatorsViewModel {

  constructor(apiClient, notificationsProvider, itemTypeFieldId) {
    this.model = new ItemTypeFieldValidatorsModel(apiClient)
    this.entity = new ItemTypeFieldValidatorsModel.ItemTypeFieldValidator()
    this.notifications = notificationsProvider
    this.itemTypeFieldId = Number(itemTypeFieldId)
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getItemTypeFieldValidators(this.itemTypeFieldId)
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    const editingEntity = entity || {item_type_field_id: this.itemTypeFieldId, sequence: 0}
    this.entity = new ItemTypeFieldValidatorsModel.ItemTypeFieldValidator(editingEntity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createItemTypeFieldValidator(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateItemTypeFieldValidator(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this entity?')) {
      try {
        const result = await this.model.deleteItemTypeFieldValidator(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'field_validator_id', label: 'ID', _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'sequence', label: 'Seq', _style: { width: '5%'} },
      { key: 'validator', label: 'Validator', _style: { width: '20%'} },
      { key: 'message', _style: { width: '40%'} },
      { key: 'value', _style: { width: '20%'} },
      {
        key: 'actions',
        label: '',
        _style: { width: '90px' },
        filter: false
      }
    ]
  }

}

ItemTypeFieldValidatorsViewModel.useInstance = function(itemTypeFieldId) {
  return useInstanceOf(ItemTypeFieldValidatorsViewModel, useApiClient(), useNotifications(), itemTypeFieldId)
}
